import { useEffect, useRef } from "react";
import { ApiTesterDirection } from "../../enums";
import { APITesterLinkedAccount } from "../../../../../models/Entities";
import useApiTesterDirection from "./useApiTesterDirection";
import useLinkedAccountType from "./useLinkedAccountType";

type UseNoLinkedAccountsRedirectProps = {
  linkedAccounts?: APITesterLinkedAccount[];
};

/**
 * Previously redirected to the Mock Sandbox tab when no linked accounts were found.
 * This behavior has been removed so the API tester always defaults to the Linked
 * Account view.
 */
const useNoLinkedAccountsRedirect = ({ linkedAccounts }: UseNoLinkedAccountsRedirectProps) => {
  // hooks
  const direction = useApiTesterDirection();
  const { linkedAccountType } = useLinkedAccountType();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (direction !== ApiTesterDirection.YOU_TO_MERGE) return;

    // mark that linked accounts have been fetched so we don't run again
    if (linkedAccounts && linkedAccounts.length && !hasFetched.current) {
      hasFetched.current = true;
    }
  }, [linkedAccountType, linkedAccounts, direction]);
};

export default useNoLinkedAccountsRedirect;
